import { render, staticRenderFns } from "./ServicesRequestInformation.vue?vue&type=template&id=99b7d644&scoped=true"
import script from "./ServicesRequestInformation.vue?vue&type=script&lang=js"
export * from "./ServicesRequestInformation.vue?vue&type=script&lang=js"
import style0 from "./ServicesRequestInformation.vue?vue&type=style&index=0&id=99b7d644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b7d644",
  null
  
)

export default component.exports